import {
  BaseUserProfile,
  IMarketingAnalyticsProvider,
  ILogger,
  GymTypes,
} from 'fitbeat.models';
import { NotificationService } from 'fitbeat.notification-service';

export class TransactionalNotificationsProvider implements IMarketingAnalyticsProvider {
  public readonly name = 'TransactionalNotifications';

  constructor(
    private readonly notificationService: NotificationService,
    private logger: ILogger,
  ) {}

  public async syncCustomer(): Promise<void> {
    this.logger.debug(`[${this.name}] syncCustomer not implemented`);
  }

  public async logEvent(
    event: string,
    userProfile: BaseUserProfile,
    data: any,
  ): Promise<void> {
    try {
      switch (event) {
        case 'workout_booked':
          if (data.workoutCount !== 0) {
            break;
          }
          if (data.memberMainGymType === GymTypes.Home && data.type === 'home') {
            await this.notificationService.sendFirstHomeWorkoutBookedEmail({
              uid: userProfile.uid,
              email: userProfile.email,
            });
          } else if (data.memberMainGymType === GymTypes.Indoor && data.type !== 'home') {
            await this.notificationService.sendFirstStudioWorkoutBookedEmail({
              uid: userProfile.uid,
              startTime: data.startTime,
              location: data.location,
              gymTimezone: data.gymTimezone,
            });
          }
          this.logger.info(`[${this.name}] Sent workout booked email to ${userProfile.email}.`);
          break;

        case 'workout_completed':
          if (data.workoutCount === 1) {
            await this.notificationService.sendPostFirstWorkoutEmail({
              uid: userProfile.uid,
            });
            this.logger.info(`[${this.name}] Sent post first workout email to ${userProfile.email}.`);
          } else if (data.workoutCount === 2) {
            await this.notificationService.sendPostSecondWorkoutEmail({
              uid: userProfile.uid,
            });
            this.logger.info(`[${this.name}] Sent post second workout email to ${userProfile.email}.`);
          }
          break;

        case 'sign_up_preaccount_created':
          await this.notificationService.sendAccountCreatedEmail({
            uid: userProfile.uid,
            appUrl: 'https://invite.fitillion.com/install-app',
          });
          this.logger.info(`[${this.name}] Sent account created email to ${userProfile.email}.`);
          break;

        case 'sign_up_studio_complete':
          await this.notificationService.sendStudioOnboardingEmail({
            uid: userProfile.uid,
            dashboardUrl: 'https://invite.fitillion.com/dashboard',
          });
          this.logger.info(`[${this.name}] Sent studio onboarding email to ${userProfile.email}.`);
          break;

        case 'sign_up_home_complete':
          await this.notificationService.sendHomeOnboardingEmail({
            uid: userProfile.uid,
            dashboardUrl: 'https://invite.fitillion.com/dashboard',
          });
          this.logger.info(`[${this.name}] Sent home onboarding email to ${userProfile.email}.`);
          break;

        default:
          this.logger.debug(`[${this.name}] Event ${event} does not trigger any action in this provider.`);
          break;
      }
    } catch (error: any) {
      this.logger.error(`[${this.name}] Failed to process event ${event} for user ${userProfile.uid}.`
        + ` Error: ${error.message}`);
    }
  }
}
